import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 371 173.7"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.3 93.3V4.6h35.1l18.9 56.2h.5L75.5 4.6h35.3v88.6H89.4V29.7h-.6L67.7 93.3H43.4l-21-63.6h-.6v63.6H2.3zm163.9 0c-.6-1.2-1.2-3.3-1.7-6.1-4.6 4.8-10.3 7.3-17 7.3-6.5 0-11.8-1.9-15.9-5.6-4.1-3.7-6.2-8.3-6.2-13.8 0-6.9 2.6-12.2 7.7-15.9 5.1-3.7 12.5-5.5 22-5.5h8.9v-4.3c0-3.4-.9-6-2.8-8.1-1.9-2-4.7-3-8.6-3-3.3 0-6 .8-8.2 2.5-2.1 1.7-3.2 3.8-3.2 6.3h-14.6c0-3.6 1.2-6.9 3.5-10 2.4-3.1 5.6-5.5 9.6-7.3 4.1-1.8 8.6-2.6 13.6-2.6 7.6 0 13.6 1.9 18.2 5.7 4.5 3.8 6.8 9.2 7 16.1v29.3c0 5.8.8 10.5 2.5 14v1h-14.8zm-16-10.5c2.9 0 5.6-.7 8.1-2.1 2.5-1.4 4.4-3.3 5.7-5.6V62.8h-7.9c-5.4 0-9.5.9-12.2 2.8-2.7 1.9-4.1 4.5-4.1 8 0 2.8.9 5 2.8 6.7 2 1.7 4.5 2.5 7.6 2.5z",
  class: "st1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ebd038",
  d: "M190.9 47.4c0-26.1 21.2-47.4 47.4-47.4 26.1 0 47.4 21.3 47.4 47.4 0 8.9-2.5 17.2-6.7 24.3l26.5 21.6h-29.1l-9.7-7.9c-8 5.9-17.8 9.4-28.4 9.4-26.2 0-47.4-21.3-47.4-47.4zM250.2 72l-13-10.6 11.6-14.2 13.8 11.2c1.6-3.4 2.3-7.1 2.3-11 0-14.9-11.8-27.5-26.6-27.5-15 0-26.7 12.7-26.7 27.5s11.8 27.5 26.7 27.5c4.3 0 8.4-1 11.9-2.9z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M370.3 93.3h-15.9l-17.8-25h-7.9v25h-12.9V27.7h26.5c2.7 0 5.3.5 7.8 1.6 2.4 1.1 4.6 2.5 6.4 4.4 1.8 1.8 3.3 4 4.4 6.4 1.1 2.4 1.6 5.1 1.6 7.9 0 4.1-1.1 7.8-3.2 11.1s-4.9 5.7-8.3 7.3l19.3 26.9zm-30.5-38c3.3 0 5.7-.7 7.3-2.2 1.6-1.5 2.3-3.2 2.3-5.2s-.8-3.7-2.3-5.1c-1.6-1.4-4-2.1-7.3-2.1h-11.1v14.6h11.1z",
  class: "st1"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ecd137",
  d: "m368.7 153.2-55-44.8-.3-1.4L.7 157.4l2.7 16.3 304.7-49.1 50.4 41.2z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }